<!-- 云课堂 -->
<template>
    <div>
        <a-layout>
            <!-- 简介窗口 -->
            <a-modal :title="introTitle" :visible="introVisible" :zIndex="88" :footer="null" :centered="true"
                     @cancel="handleIntroCancel">
                <div>
                    {{introData.intro ? introData.intro : '无简介信息'}}
                </div>
            </a-modal>
            <!-- 标题栏 -->
            <a-row class="title-row">
                <a-col :span="12">
                    <span>
                         ⚪ 云课堂&nbsp;·&nbsp;直播
                    </span>
                </a-col>
                <a-col :span="12" style="text-align: right;">
                    <a-button type="primary" icon="audio" @click="gotoLecturer()">我是讲师</a-button>
                </a-col>
            </a-row>
            <!-- 查询展示栏 -->
            <a-list size="small" :pagination="false"
                    :grid="{ gutter: 16, column: 4 }"
                    bordered
                    class="data-list"
                    :loading="loading"
                    :data-source="data">
                <!-- 查询条件 -->
                <div slot="header">
                    <a-row class="margin-top">
                        <a-col :span="23">
                            <a-space size="small">
                                <a-input placeholder="请输入课堂或讲师关键字" v-model="queryParam.searchValue" allow-clear
                                         @pressEnter="queryList(true)">
                                    <a-select slot="addonBefore" v-model="queryParam.flagEnd" style="width: 120px" @change="queryList(true)">
                                        <a-select-option :value="0">正在进行</a-select-option>
                                        <a-select-option :value="1">已结束</a-select-option>
                                    </a-select>
                                </a-input>
                                <a-button type="primary" icon="search" @click="queryList(true)">查询</a-button>
                            </a-space>
                        </a-col>
                    </a-row>
                </div>
                <!-- 查询结果列表 -->
                <a-list-item slot="renderItem" slot-scope="item, index">
                    <a-card hoverable :body-style="{padding:'0'}" class="list-card">
                        <table>
                            <tr>
                                <td width="36%">
                                    <img v-if="!item.picture || item.picture.indexOf('http')===-1" class="live-picture"
                                         src="../../assets/images/cloud_live.png" />
                                    <img v-if="item.picture" class="live-picture"
                                         :src="item.picture" />
                                </td>
                                <td class="live-info" width="64%">
                                    <p class="live-title" :title="item.classroomName">{{item.classroomName}}</p>
                                    <p>{{item.name}} &nbsp;&nbsp;&nbsp;&nbsp; {{item.professionalTitle}}</p>
                                    <p :title="item.hospitalName">{{item.hospitalName}}</p>
                                    <p>直播时间：{{item.liveTime ? item.liveTime.replace('T', ' ') : ''}}</p>
                                    <p class="live-status">
                                        <span style="width: 80%;display: inline-block;">
                                            {{item.status === 0 ? '正在进行' : item.status === 1 ? '即将开始' : '已结束'}}
                                        </span>
                                        <span class="list-card-intro" @click="handleIntro(item)">
                                            简介
                                        </span>
                                    </p>
                                </td>
                            </tr>
                        </table>
                        <p class="list-card-btn" v-if="item.status===0" @click="gotoLive(item.url)" >观看直播</p>
                        <p class="list-card-btn-unused" v-if="item.status===1">马上开始</p>
                        <p class="list-card-btn" v-if="item.status===2" @click="gotoLive(item.url)">观看录播</p>
                    </a-card>
                </a-list-item>
                <div slot="footer" style="text-align: right">
                    <a-pagination v-model="pagination.pageNum"
                                  v-bind:pageSize="pagination.pageSize"
                                  v-bind:total="pagination.total"
                                  v-bind:showQuickJumper="pagination.showQuickJumper"
                                  v-bind:showSizeChanger="pagination.showSizeChanger"
                                  v-bind:pageSizeOptions="pagination.pageSizeOptions"
                                  show-less-items
                                  @showSizeChange="handleTableChange"
                                  @change="handleTableChange">
                    </a-pagination>
                </div>
            </a-list>
        </a-layout>
    </div>
</template>

<script>
    // import api & component
    import {getCloudClassroomPage} from "@/api/cloud-classroom";
    import {getImgURL4longAlive, getImgURL4shortAlive} from '@/api/file';
    // service
    export default {
        data() {
            return {
                // 分页参数
                pagination: {
                    show: false, pageNum: 1, pageSize: 8, total: 0,
                    showQuickJumper: true, showSizeChanger: true, pageSizeOptions: ['4', '8', '16']
                },
                queryParam: {flagLecturer: 0,
                             flagEnd:0
                },
                // v-for数据源
                data: [],
                // 加载中遮罩...
                loading: false,
                // 简介
                introTitle: '云课堂 - 简介',
                introVisible: false,
                introData: {},
            };
        },
        methods: {
            // 我是讲师
            gotoLecturer() {
                this.$pageByName("lecturerClassroomList",{real_name:'cloudLive'})
            },
            // 进入直播
            gotoLive(url) {
                window.open(url, '_blank');
            },
            // 选择页码重新执行查询
            handleTableChange(current, pageSize) {
                let _this = this;
                _this.pagination.pageNum = current;
                if (pageSize != null) {
                    _this.pagination.pageSize = pageSize;
                }
                _this.queryList(false);
            },
            // 查询
            queryList(firstPage) {
                let _this = this;
                if (firstPage) {
                    _this.pagination.pageNum = 1;
                }
                _this.loading = true;
                _this.queryParam.pageNum = _this.pagination.pageNum;
                _this.queryParam.pageSize = _this.pagination.pageSize;
                // 调用查询接口
                getCloudClassroomPage(_this.queryParam).then((response) => {
                    if (response.infoCode === 0) {
                        // 查询成功
                        _this.data = response.data.records;
                        _this.pagination.total = response.data.total;
                        // 循环处理图片
                        _this.data.forEach((item,index)=>{
                            _this.getOSSFile(item);
                        });
                    } else {
                        _this.$message.error(response.info);
                    }
                    _this.loading = false;
                }).catch((error) => {
                    if (error.response && error.response.status !== 500)
                        this.$message.error("系统异常，请稍后再试！");
                    _this.loading = false;
                });
            },
            // 获取云文件地址
            getOSSFile(item) {
                if (item.picture) {
                    getImgURL4longAlive({'fileName': item.picture}).then((response) => {
                        if (response.infoCode === 0) {
                            item.picture = response.data;
                        }
                    }).catch((error) => {
                    });
                }
            },
            handleIntro(item) {
                this.introData = item
                this.introVisible = true;
            },
            handleIntroCancel() {
                this.introVisible = false;
            },
        },
        computed: {},
        activated() {
            this.queryList(true);
        }
    }
</script>

<style scoped>
    .mt-10 {margin-top: 10px;}
    .mt-20 {margin-top: 20px;}
    .ml-10 {margin-left: 10px;}
    .ml-20 {margin-left: 20px;}

    .title-row {
        color: #3555bc;
        font-size: 18px;
        line-height: 32px;
        padding: 10px;
        border-bottom: 2px solid #5364D0;
    }

    .list-card {
        min-width: 320px;
        margin-top: 30px;
        line-height:18px;
    }
    .list-card-btn {
        margin-bottom:0;
        background: #4e59c5;
        font-size: 18px;
        color: #fff;
        padding: 9px 0;
        text-align: center;
    }
    .list-card-btn-unused {
        margin-bottom:0;
        background: #a1a1a1;
        font-size: 18px;
        color: #fff;
        padding: 9px 0;
        text-align: center;
    }
    .data-list {
        background-color: white;
        margin-top: 10px;
    }

    .live-info p {
        line-height: 24px;
        margin: 0;
        padding: 3px;
        width: 220px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .live-picture {
        width: 96%;padding:2%;max-height: 140px;
    }
    .live-title {
        font-size: 18px; font-weight: bolder;
    }
    .live-status {
        color: orange;
    }
    .list-card-intro {
        text-align: right;
        color: #7586ED;
    }
</style>